import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { CheckBox } from "@app/components/Common";
import { COLORS } from "@app/constants";
import { Text, View } from "@/styles/reactnative";
import useTradeStore from "@app/hooks/trade/tradeStore.tsx";

const OrderPreferenceCheckBox = ({
  checked,
  setOrderByValue,
  orderByValue,
  setOrderQty,
  orderQty,
  type,
  title,
  content,
  coinType,
}) => {
  const { t } = useTranslation();
  const { data: tradeStore, mutate } = useTradeStore();
  // const dd = localStorage.getItem('main_sub')
  //
  // useEffect(() => {
  //   console.log('dd',dd);
  // }, [dd]);

  const handleChange = async (e) => {
    if (tradeStore) {
      if (e) {
        localStorage.setItem('main_sub', type === "qty" ? "M" : "S");

        await mutate({
          ...tradeStore,
          main_sub: type === "qty" ? "M" : "S",
          coin_type: type === "qty" ? tradeStore?.symbol : "USDT",
          order_amount: 0,
        });

      }
    } else {
      console.error("tradeStore is undefined");
    }
  };

  return (
    <View
      style={{
        flexDirection: "row",
        width: "100%",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        marginBlock: 20,
      }}
    >
      <CheckBox
        value={checked}
        onChange={handleChange}
        borderColor={COLORS.lightGray5}
      />
      <View
        style={{ alignItems: "flex-start", width: "100%", cursor: "pointer" }}
        onClick={() => handleChange(!checked)}
      >
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Text size={12} style={{ marginBottom: 5 }}>
            {title && t(title)}
          </Text>
          <Text size={12} style={{ color: COLORS.primary, marginBottom: 5 }}>
            {coinType}
          </Text>
        </View>
        <Text size={12} style={{ color: COLORS.lightGray }}>
          {content && t(content)}
        </Text>
      </View>
    </View>
  );
};

export default OrderPreferenceCheckBox;
